<template>
  <div>
    <div class="toolPositionBox" v-if="showType==1">
      <div class="toolTitle">智签签章位置工具</div>
      <div class="toolContent">
        <div class="swiperSlidecustomerAdd" slot="upload">
          <div v-loading="loadingUpload">
            <div class="content">
              <img src="@image/personalSign/pdf_file_icon.png">
            </div>
            <upload
              :url="'/common/uploadContract'"
              class="cover"
              :uploadType="'seal'"
              @uploadSuccess="uploadSuccess"
              @loading="loadingUpload=true"
              @loadingEnd="loadingUpload=false"
            >
              <img src="@image/personalSign/Addcontract_img_hov_pre.png" slot="uploadContent">
            </upload>
            <div class="coverDscp">上传本地文件</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showType==2" class="sealPositionBox">
      <seal-position :url="fileUrl" :name="fileName"></seal-position>
    </div>
  </div>
</template>
<script>
import sealPosition from "./toolPosition/sealPosition.vue";
import upload from "@common/upload.vue";
export default {
  data() {
    return {
      loadingUpload: false,
      showType: 1,
      fileUrl:
        "http://xcon-test.oss-cn-beijing.aliyuncs.com/contract/1834/20190514/1a386db7a16f4a4895101d80ccb29bbe.pdf",
      fileName: "测试文件"
    };
  },
  methods: {
    uploadSuccess(res) {
      this.fileUrl = res.datas.fileUrl;
      this.showType = 2;
    },
    changeUrl(url) {
      console.log(url);
      this.fileUrl = url;
      this.showType = 2;
    }
  },
  components: {
    upload,
    sealPosition
  }
};
</script>
<style lang="scss" scope>
.sealPositionBox {
  width: 1190px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 20px;
}
.toolPositionBox {
  max-width: 1180px;
  margin: 0 auto;
  height: 510px;
  background: #ffffff;
  border: 1px solid #e4e8eb;
  border-radius: 0 3px 3px 3px;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  .toolTitle {
    background: #f8f8f8;
    line-height: 40px;
    font-size: 14px;
    color: #505050;
    text-align: center;
  }
  .toolContent {
    width: 100%;
    height: 470px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .swiperSlidecustomerAdd {
    width: 160px;
    height: 200px;
    position: relative;
    cursor: pointer;
    .content {
      &:hover {
        background-color: rgb(240, 240, 240);
      }
      width: 100%;
      height: 146px;
      box-sizing: border-box;
      padding: 10px;
      background-color: rgb(248, 248, 248);
      display: flex;
      justify-content: center;
      align-items: center;
      .selectDscp {
        font-size: 14px;
        color: #646464;
        margin-top: 14px;
      }
    }
    .slectHeight {
      height: 200px;
      flex-direction: column;
    }
    .cover {
      display: none;
    }
    &:hover {
      .cover {
        position: absolute;
        display: block;
        width: 100%;
        height: 146px;
        left: 0;
        top: 0;
        z-index: 1;
        img {
          height: 146px;
          width: 160px;
          display: block;
        }
      }
    }
  }
  .coverDscp {
    position: absolute;
    z-index: 2;
    width: 160px;
    box-sizing: border-box;
    height: 55px;
    line-height: 55px;
    bottom: 0;
    border: 1px solid rgb(240, 240, 240);
    background-color: white;
    font-size: 14px;
    color: #646464;
    text-align: center;
  }
}
</style>
